import { memo, useCallback } from 'react';

import { DeliveryType } from '../lib/types';

interface FulfillmentProps {
  deliveryType: DeliveryType;
  onSetDeliveryType: (type: DeliveryType) => void;
}

const Fulfillment: React.FC<FulfillmentProps> = ({ deliveryType, onSetDeliveryType }) => {
  const onChange = useCallback(
    (type: DeliveryType) => {
      if (type !== deliveryType) {
        onSetDeliveryType(type);
      }
    },
    [deliveryType, onSetDeliveryType]
  );

  return (
    <div className="border-pink-300 border-0 rounded-full flex items-center w-72 relative bg-gray-100">
      <div
        className={`z-10 text-center lg:text-sm px-5 py-1.5 w-1/2 rounded-full cursor-pointer transition-colors duration-200 ease-in-out ${
          deliveryType === DeliveryType.request ? 'text-white' : 'text-gray-400'
        }`}
        onClick={() => onChange(DeliveryType.request)}
      >
        Request stuff
      </div>
      <div
        className={`z-10 text-center lg:text-sm px-5 py-1.5 w-1/2 rounded-full cursor-pointer transition-colors duration-200 ease-in-out ${
          deliveryType === DeliveryType.send ? 'text-white' : 'text-gray-400'
        }`}
        onClick={() => onChange(DeliveryType.send)}
      >
        Send stuff
      </div>
      <div
        className={`absolute top-0 bottom-0 w-1/2 bg-pink-300 rounded-full transition-transform duration-200 ease-in-out transform ${
          deliveryType === DeliveryType.request ? 'translate-x-0' : 'translate-x-full'
        }`}
      />
      <div className="absolute left-0 bottom-0 right-0 top-0 border-2 border-pink-300 rounded-full" />
    </div>
  );
};

export default memo(Fulfillment);
